import { styled } from '@mui/material';

export const AppStyles = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
}));

export const IndexStyles = styled('div')(() => ({
  display: 'flex',
  height: '100vh',
  width: '100vw',
}));
